import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { COMPATIBLE_PRODUCT_FILTER_VALUES, FILTER_KEYS, resolveAlgoliaSearchIndex, useAlgoliaConfig } from '@atlassian/mpac-utils';
import AlgoliaSearch from 'algoliasearch/lite';
import { useEffect, useState } from 'react';
import { enterpriseAppsSectionMetaData } from '../../Homepage/constants';
import { getSearchAttributesToRetrieve } from '../../utils';
// TODO: Replace with value from bootstrap config
const searchClient = AlgoliaSearch('7LVR1JKTDF', '3ef48f0fc67ee7e9c5a9dbbf6b45908c');
export function useEnterpriseAppsSection() {
  let {
    productId,
    shouldExitEarly = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    environment: algoliaEnvironment
  } = useAlgoliaConfig();
  const {
    enableV2SearchIndex
  } = useFeatureFlags();
  const [enterpriseAppsSectionStatus, setEnterpriseAppsSectionStatus] = useState('idle');
  const [enterpriseAppsSectionData, setEnterpriseAppsSectionData] = useState(null);
  const [enterpriseAppsSectionDataError, setEnterpriseAppsSectionDataError] = useState(null);
  useEffect(() => {
    setEnterpriseAppsSectionData(null);
    if (shouldExitEarly) {
      setEnterpriseAppsSectionStatus('resolved');
      return;
    }
    async function fetchEnterpriseAppsSection() {
      try {
        const indexName = resolveAlgoliaSearchIndex(algoliaEnvironment, enableV2SearchIndex);
        const productFilter = productId ? ["version.compatibilities.applicationKey:".concat(COMPATIBLE_PRODUCT_FILTER_VALUES[productId])] : [];
        setEnterpriseAppsSectionStatus('loading');
        const response = await searchClient.search([{
          indexName,
          params: {
            attributesToHighlight: [],
            attributesToRetrieve: getSearchAttributesToRetrieve(),
            facetFilters: ['programs.cloudFortified.status:approved', ...productFilter],
            hitsPerPage: 6
          }
        }]);
        const {
          hits
        } = response.results[0];
        if (hits && hits.length > 0) {
          let navigationUrl = "/search?".concat(FILTER_KEYS.TRUST_SIGNALS, "=").concat(FILTER_KEYS.CLOUD_FORTIFIED);
          if (productId) {
            navigationUrl += "&".concat(FILTER_KEYS.PRODUCT, "=").concat(COMPATIBLE_PRODUCT_FILTER_VALUES[productId]);
          }
          const enterpriseAppsSection = _objectSpread(_objectSpread({}, enterpriseAppsSectionMetaData), {}, {
            navigationUrl,
            apps: hits
          });
          setEnterpriseAppsSectionData(enterpriseAppsSection);
          setEnterpriseAppsSectionStatus('resolved');
        } else {
          setEnterpriseAppsSectionDataError(new Error('No enterprise apps found'));
          setEnterpriseAppsSectionStatus('rejected');
        }
      } catch (err) {
        setEnterpriseAppsSectionDataError(err);
        setEnterpriseAppsSectionStatus('rejected');
      }
    }
    fetchEnterpriseAppsSection();
  }, [shouldExitEarly, algoliaEnvironment, productId, enableV2SearchIndex]);
  const isEnterpriseAppsSectionLoading = enterpriseAppsSectionStatus === 'loading';
  const isEnterpriseAppsSectionLoadError = enterpriseAppsSectionStatus === 'rejected';
  return {
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionStatus,
    enterpriseAppsSectionData,
    enterpriseAppsSectionDataError
  };
}